import { graphql } from '../gql'

/**
 * GraphQL operations for order photos. Kept out of GetOrderDetail on purpose:
 * photo URLs are short-lived presigned links, so the gallery fetches
 * cache-and-network without disturbing the big cache-first order query.
 */

/** Query: photos uploaded to an order (thumb/url are presigned, ~1h). */
export const GetOrderPhotos = graphql(`
	query GetOrderPhotos($orderId: Int!) {
		order(id: $orderId) {
			id
			photos {
				id
				clientId
				thumbUrl
				url
				takenAt
				createdAt
				uploadedByName
			}
		}
	}
`)

/**
 * Query: photo count for the order detail row. Deliberately skips the
 * presigned URL fields — the API signs those per photo, and the row only
 * renders a number.
 */
export const GetOrderPhotoCount = graphql(`
	query GetOrderPhotoCount($orderId: Int!) {
		order(id: $orderId) {
			id
			photos {
				id
				clientId
			}
		}
	}
`)

/** Mutation: presigned PUT urls for both renditions of a new photo. */
export const PresignOrderPhotoUpload = graphql(`
	mutation PresignOrderPhotoUpload(
		$orderId: Int!
		$data: OrderPhotoPresignInput!
	) {
		orderPhoto {
			presignUpload(where: { id: $orderId }, data: $data) {
				photoUploadUrl
				thumbUploadUrl
			}
		}
	}
`)

/** Mutation: record the photo after both PUTs succeed (idempotent on clientId). */
export const CreateOrderPhoto = graphql(`
	mutation CreateOrderPhoto($orderId: Int!, $data: OrderPhotoCreateInput!) {
		orderPhoto {
			create(where: { id: $orderId }, data: $data) {
				id
				clientId
				thumbUrl
				url
				width
				height
				takenAt
				createdAt
				uploadedByName
			}
		}
	}
`)
